import {Component, Input, OnInit} from '@angular/core';
import {AbstractFields} from '../_abstract';
import {TechnicalDocument, TechnicalDocumentsProvider} from '../../../../../providers/technical-documents/technical-documents.provider';

@Component({
    selector: 'app-std-common',
    template: `
        <app-std-layout>
            <std-table [documents]="documents"></std-table>
        </app-std-layout>
    `
})

export class StdCommonComponent extends AbstractFields implements OnInit {
    public documents: TechnicalDocument[] = [];
    constructor(
        private documentsProvider: TechnicalDocumentsProvider,
    ) {
        super();
    }

    ngOnInit() {
        super.ngOnInit();
        this.documents = this.documentsProvider.getCommonDocuments();
    }
}
